import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import PayoutsList from '@Components/Vendors/VendorProfile/VendorPayments/PayoutsList';

/**
 *
 */
class VendorProducts extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <div className="vendor-payouts__wrapper">
        <PayoutsList />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
});

VendorProducts.propTypes = {
  match: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorProducts));
